<!-- Copyright (c) 2025 MOCA Systems, Inc.  All rights reserved. -->
<div *ngIf="imageState$ | async as imageState" class="secure-image-container">
	<!-- Main Image -->
	<ng-container *ngIf="imageUrl$ | async as url">
		<img
			*ngIf="imageState !== 'error'"
			[src]="url"
			[alt]="alt"
			[attr.aria-label]="alt"
			(click)="onImageClickEvent()"
			[matTooltip]="appStrings.CLICK_TO_EXPAND"
		/>
	</ng-container>

	<!-- Error State with Retry -->
	<div
		[matTooltip]="appStrings.IMAGE_COLLECTION_CLICK_TO_RELOAD_IMAGE"
		*ngIf="imageState === 'error'"
		class="error-content"
		[attr.aria-label]="'Failed to load ' + alt"
		(click)="retry()"
	>
		<mat-icon>refresh</mat-icon>
		<p class="error-message">{{ appStrings.IMAGE_COLLECTION_RELOAD_IMAGE }}</p>
	</div>
</div>
